<form [formGroup]="DatosServicioTransporteFormGroup">
    <ng-template matStepLabel>Servicio</ng-template>

    <h2 class="main-div"><b>Datos del Servicio de Transporte</b></h2>

    <p style="font-size: 11px;padding: 0px;"><b>Nota:</b> Los campos marcados con * son obligatorios.</p>

    <div style="text-align: center; padding-top: 0px;">

        <mat-form-field appearance="outline" style="width: 100%;padding-bottom:0%">
            <mat-label>Tipo Servicio Transporte</mat-label>
            <mat-select formControlName="TipoServicioTransporte" (ngModelChange)="cambioTipoServicio()" required
                [ngClass]="{'is-invalid': invalidField('TipoServicioTransporte')}" autocomplete="off">
                <mat-option value="COMPLETO">COMPLETO (ida y vuelta al mismo sitio)</mat-option>
                <mat-option value="DOBLE RUTA">DOBLE RUTA (retorno otro sector COSTO ADICIONAL
                    30%
                    al
                    recorrido completo )</mat-option>
                <mat-option value="OPCIONAL SOLO ENTRADA">OPCIONAL SOLO ENTRADA (costo 80% del
                    recorrido
                    COMPLETO)</mat-option>
                <mat-option value="OPCIONAL SOLO SALIDA">OPCIONAL SOLO SALIDA (costo 80% del
                    recorrido
                    COMPLETO)</mat-option>
            </mat-select>

            <mat-error *ngIf="TipoServicioTransporte.invalid && TipoServicioTransporte.errors?.required"
                class="messagererrors textColorText">
                Campo <strong>requerido.</strong>
            </mat-error>

        </mat-form-field>
    </div>


    <div class="row">
        <div class="col-md-6" style="text-align: center;">
            <div class="form-group">

                <mat-form-field appearance="outline" style="width: 100%;">
                    <mat-label>Dirección Exacta - con calles, números y referencias</mat-label>
                    <input matInput placeholder="Dirección Exacta" formControlName="DireccionExacta" required
                        [ngClass]="{'is-invalid': invalidField('DireccionExacta')||DireccionExacta.invalid && DireccionExacta.errors?.pattern}">

                    <mat-error *ngIf="DireccionExacta.invalid && DireccionExacta.errors?.required"
                        class="messagererrors textColorText">
                        Campo <strong>requerido.</strong>
                    </mat-error>


                    <mat-error *ngIf="DireccionExacta.invalid && DireccionExacta.errors?.pattern"
                        class="messagererrors textColorText">
                        Campo <strong> númerico.</strong>
                    </mat-error>
                </mat-form-field>

                <label style="text-align: justify;">Posicione el icono <mat-icon> place</mat-icon>
                    del mapa en el punto donde será embarcado el estudiante. </label>
                <div style="font-size: 80%;cursor: pointer;color: blue;" (click)="helperMap()">¡Necesito
                    ayuda!</div>
                <ngx-place-picker (locationChanged)="this.locationDireccionChange($event)"
                    [enableCurrentLocation]="true" [enablePlacesSearch]="true"
                    [defaultLocation]="{'lat':latitudRecoijida,'lng':longitudRecojida,'zoom':13}">
                </ngx-place-picker>
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group">
                <div *ngIf="tieneRetorno" style="text-align: center;">

                    <mat-form-field style="width:100%" appearance="outline">
                        <mat-label>Dirección Exacta Retorno con calles, números y referencias
                        </mat-label>
                        <input matInput placeholder="Dirección Exacta Retorno" formControlName="DireccionExactaRetorno"
                            required>


                        <mat-error class="messagererrors textColorText" *ngIf="direccionRetornoP">
                            Campo <strong> requerido.</strong>
                        </mat-error>


                    </mat-form-field>




                    <label style="text-align: justify;">Posicione el icono <mat-icon> place</mat-icon>
                        del mapa en el punto donde será desembarcado el estudiante. </label>
                    <div style="font-size: 80%;cursor: pointer;color: blue;" (click)="helperMap()">¡Necesito
                        ayuda!</div>
                    <ngx-place-picker (locationChanged)="this.locationDireccionRetornoChange($event)"
                        [enableCurrentLocation]="true" [enablePlacesSearch]="true"
                        [defaultLocation]="{'lat':this.latitudDeja,'lng':this.longitudDeja,'zoom':13}">
                    </ngx-place-picker>
                </div>
            </div>
        </div>
    </div>





</form>